// src/utils/portalFormOverrides.js
// Read/write the admin-configurable portal form overrides at
// portalConfig/formOverrides. The doc holds only field definitions (labels,
// required flags, options, added fields, ordering) — no client data — so it is
// world-readable (the unauthenticated seller page needs it). See firestore.rules.
import { doc, getDoc, setDoc } from "firebase/firestore";
import { firestored } from "../firebase/firebaseConfig";

const overridesRef = () => doc(firestored, "portalConfig", "formOverrides");

// Returns the { [formId]: FormOverride } map, or {} on a missing doc / any
// error. Never throws — callers treat "no overrides" as the base forms.
export async function loadPortalFormOverrides() {
  try {
    const snap = await getDoc(overridesRef());
    if (!snap.exists()) return {};
    return (snap.data() || {}).forms || {};
  } catch (err) {
    console.error("loadPortalFormOverrides failed:", err);
    return {};
  }
}

// Overwrite the overrides doc with the complete desired state. The editor
// always sends the full cleaned map, so a full replace (NOT { merge: true }) is
// correct: nested-map merge never deletes omitted keys, which would silently
// resurrect overrides the Team Lead removed (reset field, reset form, cleared
// title). A whole-doc write lets those removals persist. Only the Team Lead can
// write (firestore.rules).
export async function savePortalFormOverrides(formsMap) {
  await setDoc(overridesRef(), { forms: formsMap || {} });
}
